import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { CustomModal } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { withStoreActions } from '~/store/store-context';
import GenericError from '../GenericError/GenericError';
import { getDisplayMessage, isSentryIgnoredError } from './sentryIgnoredError';
export const GetErrorBoundaryPageTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ErrorBoundaryPageTID: {
                Root: 'error-boundary-page'
            }
        }
    });
class ErrorBoundaryPage extends Component {
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            displayMessage: getDisplayMessage(error)
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname || prevProps.location.search !== this.props.location.search) {
            this.setState({
                hasError: false,
                displayMessage: undefined
            });
        }
    }
    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error(error);
        if (!isSentryIgnoredError(error)) {
            Sentry.withScope((scope)=>{
                const errorLike = error;
                scope.setContext('Error data', typeof (errorLike === null || errorLike === void 0 ? void 0 : errorLike.message) === 'string' ? {
                    message: errorLike.message,
                    stack: errorLike.stack
                } : {
                    rawError: JSON.stringify(error)
                });
                Sentry.captureException('ErrorBoundaryPage caught an error');
            });
            this.props.actions.logBI(18300);
        }
    }
    render() {
        const { bounded, isModal, children, dismissModal } = this.props;
        const { hasError, displayMessage } = this.state;
        const { ErrorBoundaryPageTID } = GetErrorBoundaryPageTID();
        const errorPage = /*#__PURE__*/ _jsx(GenericError, {
            fullPage: !bounded && !isModal,
            message: displayMessage,
            testId: ErrorBoundaryPageTID.Root()
        });
        return hasError ? isModal ? /*#__PURE__*/ _jsx(CustomModal, {
            bi: {
                closeButton: {
                    name: 'error_boundary_modal_close'
                }
            },
            onClose: dismissModal,
            children: errorPage
        }) : errorPage : children;
    }
    constructor(...args){
        super(...args), _define_property(this, "state", {
            hasError: false,
            displayMessage: undefined
        });
    }
}
const ErrorBoundaryPageWithStore = withStoreActions(ErrorBoundaryPage);
export default function ErrorBoundaryPageRouted(props) {
    const location = useLocation();
    return /*#__PURE__*/ _jsx(ErrorBoundaryPageWithStore, _object_spread_props(_object_spread({}, props), {
        location: location
    }));
}
